import type { MockSectionInsights } from '../types';

const getMockSectionInsights = (): MockSectionInsights => ({
    unitEconomicsInsight: {
        text:
            'Acquisition economics work (3:1 LTV:CAC, 5-month payback); the broken number is ' +
            '19% gross margin — fix cost to serve, not sales.',
        tone: 'warning',
    },
    retentionInsight: {
        text:
            'NRR 108% with 3.6% logo churn — retention compounds. Watch the month-1 cohort ' +
            'drop (5–9%): the earliest exits never activated.',
        tone: 'positive',
    },
    engagementInsight: {
        text:
            '1 in 3 signups never reaches a first successful workflow — activation is the top ' +
            'innovation candidate for both growth and retention.',
        tone: 'warning',
    },
    organizationsInsight: {
        text:
            'Half the portfolio funds the other half: Initech, Globex and Umbrella Ops wipe out ' +
            'most of the margin Acme and Northwind earn.',
        tone: 'negative',
    },
});

export default getMockSectionInsights;
